import { useState, useCallback, useRef } from 'react';
import { ActiveFilter, FilterComparator } from '@utils/filters';
import { useOnClickOutside, useDebounceCallback  } from 'usehooks-ts'

export const useFilters = (onFiltersChange?: (filters: ActiveFilter[]) => void) => {
    const [activeFilters, setActiveFilters] = useState<ActiveFilter[]>([]);
    const [sentFilters, setSentFilters] = useState<ActiveFilter[]>([]);
    const [isAddFilterModalOpen, setIsAddFilterModalOpen] = useState<boolean>(false);
    const debounced = useDebounceCallback(setIsAddFilterModalOpen, 250)
    const ref = useRef(null)

    const addFilter = useCallback((filterId: string, value: string | string[] | boolean | Date, comparator?: FilterComparator) => {
        setActiveFilters(prev => {
            const filterExists = prev.find(f => f.id === filterId);
            if (filterExists) {
                return prev.map(f => 
                    f.id === filterId 
                        ? { ...f, comparator, value }
                        : f
                );
            }
            return [...prev, { id: filterId, comparator: comparator || 'equals', value }];
        });
    }, []);

    const removeFilter = useCallback((filterId: string) => {
        setActiveFilters(prev => prev.filter(f => f.id !== filterId));
    }, []);

    const clearFilters = useCallback(() => {
        onFiltersChange?.([]);
        setActiveFilters([]);
        setSentFilters([]);
        setIsAddFilterModalOpen(false);
    }, []);

    const sendFilters = useCallback(() => {
        onFiltersChange?.(activeFilters);
        setSentFilters(activeFilters);
        setIsAddFilterModalOpen(false);
    }, [activeFilters, onFiltersChange]);

    useOnClickOutside(ref, () => {
        debounced(false);
    })

    return {
        activeFilters,
        addFilter,
        removeFilter,
        clearFilters,
        sentFilters,
        ref,
        isAddFilterModalOpen,
        setIsAddFilterModalOpen,
        sendFilters
    };
};